var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags"},_vm._l((_vm.list),function(tag,index){return _c('DSTooltip',{key:tag.name + index,attrs:{"text":tag.tooltip}},[_c('DSTag',{attrs:{"color":tag.color,"background-color":tag.background,"text":tag.name}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }